/**
 * ⇧↵ / "Follow keyword" from search (§3.4 row 4, screenshots/113–114). Legislation, people, committees and keywords
 * go through the follows store (its toast and Undo); an organization through its own follow (dashboard-orgs.js).
 */
import { followsStore } from "../stores/followsStore";
import { toastStore } from "../stores/toastStore";
import { isFollowed } from "../lib/followText";
import type { SearchFollow } from "./search";

const followedOrgs = new Set<string>();

export const isSearchFollowed = (f: SearchFollow | undefined, follows = followsStore.getState().follows) =>
  !!f && (f.type === "organization" ? !!f.refId && followedOrgs.has(f.refId) : isFollowed(follows, f as Parameters<typeof isFollowed>[1]));

export async function followFromSearch(f: SearchFollow): Promise<boolean> {
  if (isSearchFollowed(f)) return true;
  if (f.type !== "organization") {
    const saved = await followsStore.getState().follow({ type: f.type, label: f.label, ...(f.refId ? { refId: f.refId } : {}), ...(f.keyword ? { keyword: f.keyword } : {}) });
    return !!saved;
  }
  const res = await fetch(`/api/dashboard/orgs/${encodeURIComponent(f.refId ?? "")}/follow`, {
    method: "PUT", credentials: "include", headers: { "content-type": "application/json" }, body: JSON.stringify({ following: true }),
  }).catch(() => null);
  if (!res?.ok) { toastStore.getState().show({ message: "Couldn't follow that. Try again." }); return false; }
  followedOrgs.add(f.refId!);
  toastStore.getState().show({ message: "Following. New matches will show up in Following." });
  return true;
}
